/**
 * Used to make requests to the ITranslationService.
 * The endpoint takes only api key, but this request
 * is used for consistency in service method declarations
 */
export class TranslationGroupsRequest {
  public static readonly instance = new TranslationGroupsRequest()
}
